import React, { HTMLAttributes, useEffect, useMemo, useState } from "react";
import cx from "classnames";
import { Hooks } from "@xt/xtbase";
const { useTranslation } = Hooks;
import { useStore } from "../../store";

import PasskeyVerify from "../../Verify";
import ListFaType1 from "../../ListFaType1";
import ItemInput from "../../ItemInput";

import styles from "./index.module.scss";

import { FaCheckItemProps, ModalTitleProps } from "../../Modal";
import { VerifyTypeEnum } from "../../ItemButton";

enum ModeEnum {
  list = "list", //列表选择页
}

type ModeType = ModeEnum | VerifyTypeEnum;

interface Props extends HTMLAttributes<HTMLDivElement> {
  faBizType: number;
  dynamicCodeType: string;
  faCheckItemData: FaCheckItemProps;
  successCallback: (arg?: any) => void;
  setDisabled: (arg: boolean) => void;
  setModalTitle: (arg: ModalTitleProps | undefined) => void;
  msgSendDataObj?: any;
}

const ValidateItemAry = [
  VerifyTypeEnum.email,
  VerifyTypeEnum.mobile,
  VerifyTypeEnum.google,
];

const Main: React.FC<Props> = ({
  faBizType,
  dynamicCodeType,
  faCheckItemData,
  successCallback,
  setDisabled,
  setModalTitle,
  msgSendDataObj,
  className,
}) => {
  const t = useTranslation();
  const { isPasskeySupport: appIsPasskeySupport } = useStore();

  const [mode, setMode] = useState<ModeType>();
  useEffect(() => {
    setModalTitle(
      mode === ModeEnum.list
        ? { label: t("@xt/Passkey.selectVerifyWay") }
        : undefined
    );
  }, [mode]);

  const isPasskeySupport = useMemo(() => {
    if (faCheckItemData && faCheckItemData.passkeyEnable && appIsPasskeySupport)
      return true;
    return false;
  }, [faCheckItemData, appIsPasskeySupport]);

  useEffect(() => {
    if (isPasskeySupport) return setMode(VerifyTypeEnum.passkey);
    const faItem = faCheckItemData.faItems[0];
    const mode = ValidateItemAry[faItem.validateItemType];
    setMode(mode);
  }, []);

  const itemInputProps: any = {
    faBizType,
    dynamicCodeType,
    faCheckItemData,
    isFaResult: true,
    successCallback,
    setDisabled,
    msgSendDataObj,
    // onSwitch: () => setMode(ModeEnum.list),
  };
  if (isPasskeySupport || faCheckItemData.faItems.length > 1) {
    itemInputProps.onSwitch = () => setMode(ModeEnum.list);
  }

  return (
    <div className={cx(styles.main, className)}>
      {mode === ModeEnum.list && (
        <ListFaType1
          isPasskey={isPasskeySupport}
          faItems={faCheckItemData.faItems}
          clickFun={setMode}
        />
      )}
      {mode === VerifyTypeEnum.passkey && (
        <PasskeyVerify
          faBizType={faBizType}
          faCheckId={faCheckItemData.faCheckId}
          successCallback={successCallback}
          updateLoading={setDisabled}
          onSwitch={() => setMode(ModeEnum.list)}
        />
      )}
      {mode === VerifyTypeEnum.email && (
        <ItemInput type={VerifyTypeEnum.email} {...itemInputProps} />
      )}
      {mode === VerifyTypeEnum.mobile && (
        <ItemInput type={VerifyTypeEnum.mobile} {...itemInputProps} />
      )}
      {mode === VerifyTypeEnum.google && (
        <ItemInput type={VerifyTypeEnum.google} {...itemInputProps} />
      )}
    </div>
  );
};

export default Main;
